import React from 'react';
import { colors } from '../../constants.js/colors';
import { legalUrls } from '../../constants.js/misc';
import { Grid, Link, Typography } from '@material-ui/core';

const footerLinkStyle = {
    color: 'inherit',
    textDecoration: 'underline',
};

const AuthFooterSecondary = () => {
    return (
        <Grid container justify="center" xs={12} style={{ backgroundColor: colors.primary.main, padding: '12px', gap: '8px' }}>
            <Typography display="inline" variant="caption">
                ⓒ 2025 Cometric S.A.S.
            </Typography>
            <Typography display="inline" variant="caption">
                |
            </Typography>
            <Typography display="inline" variant="caption">
                Todos los derechos reservados.
            </Typography>
            <Typography display="inline" variant="caption">
                |
            </Typography>
            <Link href={legalUrls.terms} target="_blank" rel="noopener noreferrer" style={footerLinkStyle}>
                <Typography display="inline" variant="caption" component="span">
                    Términos y Condiciones
                </Typography>
            </Link>
            <Typography display="inline" variant="caption">
                |
            </Typography>
            <Link href={legalUrls.contactWhatsApp} target="_blank" rel="noopener noreferrer" style={footerLinkStyle}>
                <Typography display="inline" variant="caption" component="span">
                    Contáctanos
                </Typography>
            </Link>
            <Typography display="inline" variant="caption">
                |
            </Typography>
            <Link href={legalUrls.privacy} target="_blank" rel="noopener noreferrer" style={footerLinkStyle}>
                <Typography display="inline" variant="caption" component="span">
                    Políticas de Privacidad
                </Typography>
            </Link>
        </Grid>
    );
};

export default AuthFooterSecondary;
